import { FC, useEffect } from "react";
import { Image } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";
import { useIsPageLoading } from "~/hooks/usePageIsLoading";
import Conceive from "~/images/logos/conceive.svg";

export const LoadingPage: FC = () => {
  const { isPageLoading, setIsPageLoading } = useIsPageLoading();

  useEffect(() => {
    setIsPageLoading(true);
  }, [isPageLoading, setIsPageLoading]);

  return (
    <FullBleedSection bgColor="bg-main" h="100vh">
      <Image src={Conceive} maxW="20rem" mb="20rem" w="100%" />
    </FullBleedSection>
  );
};
